import React, { useState } from "react";
import { Container, StyledItem } from "./styles";

const Dropdown = ({
  title,
  required,
  onChange,
  value,
  error,
  errorMessage,
  additionalstyle,
  options,
  multiSelection,
  placeholder = "",
  selectorHeight,
  mainPage,
  disabled,
  hidden,
  readOnly,
}) => {
  const [isActive, setIsActive] = useState(false);

  const onSelectValue = (e) => {
    setIsActive(false);
    onChange(e.nativeEvent.target.dataset.value);
  };

  const onSelectInnerText = (e) => {
    setIsActive(false);
    onChange(e.target.innerText);
  };

  return (
    <Container
      additionalstyle={additionalstyle}
      height={selectorHeight}
      mainPage={mainPage}
      disabled={disabled}
      hidden={hidden}
      title={title}
      error={error}
    >
      {title && (
        <div className="label">
          {title}
          {required ? <span className="warning"> *</span> : null}
        </div>
      )}
      <div
        className="select"
        onClick={
          readOnly
            ? null
            : () => {
                if (!disabled) {
                  setIsActive(true);
                }
              }
        }
        onBlur={() => setIsActive(false)}
      >
        {multiSelection ? (
          value.length ? (
            value.map((element) => (
              <span className="selectedResult" key={element}>
                {options.find(
                  (option) => option.value === element || option === element
                )?.label
                  ? options.find(
                      (option) => option.value === element || option === element
                    )?.label
                  : element}
              </span>
            ))
          ) : (
            <span className="dropDownPlaceholder">{placeholder}</span>
          )
        ) : value ? (
          <span className="value">{value}</span>
        ) : (
          <span className="dropDownPlaceholder">{placeholder}</span>
        )}
      </div>
      {error ? (
        <div className="warning">
          {errorMessage?.length ? errorMessage : "Option is required."}
        </div>
      ) : null}
      {isActive ? (
        <>
          <div className="options">
            {options
              .filter((option) => {
                // For single selection, remove the currently chosen one
                if (!multiSelection) {
                  const optionValue = option.value ?? option;
                  return optionValue !== value;
                }
                return true;
              })
              .map((option, index) => {
                const isSelected = value?.includes(option.value ?? option);
                if (option.label) {
                  return (
                    <StyledItem
                      className={"option"}
                      key={option.value}
                      onClick={onSelectValue}
                      data-value={option.value}
                      isSelected={isSelected}
                    >
                      {option.label}
                    </StyledItem>
                  );
                } else if (
                  typeof option === "string" ||
                  typeof option === "number"
                ) {
                  return (
                    <StyledItem
                      className="option"
                      key={index}
                      onClick={onSelectInnerText}
                    >
                      {option}
                    </StyledItem>
                  );
                } else {
                  return null;
                }
              })}
          </div>
          <div
            className="outerContainer"
            style={{
              position: "fixed",
              top: 0,
              right: 0,
              width: "100vw",
              height: "100vh",
              zIndex: 1000,
              display: isActive ? "block" : "none",
            }}
            onClick={() => {
              setIsActive(false);
            }}
          ></div>
        </>
      ) : null}
    </Container>
  );
};

export default Dropdown;
